// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9eabf3ae] .goodsout-dialog .el-dialog__body {\n  position: fixed;\n  top: 50px;\n  bottom: 80px;\n  padding: 15px 20px;\n  left: 0;\n  right: 0;\n  overflow: auto;\n}\n.dialog-footer[data-v-9eabf3ae] {\n  left: 0;\n  right: 0;\n  text-align: center;\n  -webkit-box-shadow: 0 -2px 8px 0 #eaeaf4;\n          box-shadow: 0 -2px 8px 0 #eaeaf4;\n  height: 80px;\n  line-height: 80px;\n  bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
